<template>
    <div class="select-product">
        <el-dialog title="添加" :visible.sync="dialogVisible" width="768px" :before-close="close">
            <div class="form">
                <el-form :model="formInline" ref="formInline" class="demo-form-inline" label-position="left" label-width="0px">
                    <el-form-item>
                        <el-input v-model="formInline.create_product_name" placeholder="请输入品牌名称（中、英文用英文逗号隔开）" clearable style="width: 400px; margin-right: 20px"></el-input>
                        <el-button @click="createProduct" size="medium" type="primary" :loading="addLoad">添加</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="table">
                <el-table v-loading="tabload" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" stripe>
                    <el-table-column label="编号ID" align="center" prop="id" width="100px"> </el-table-column>
                    <el-table-column prop="name" label="品牌名称" align="center"> </el-table-column>
                    <el-table-column prop="opt" label="操作" align="center">
                        <template slot-scope="scope">
                            <div class="link">
                                <el-link type="primary" @click="EditProShow(scope.row)">编辑</el-link>
                                <el-link type="danger" @click="deleteProduct(scope.row.id)">删除</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pageList">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="size"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        background
                    >
                    </el-pagination>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false" size="medium">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="编辑" :visible.sync="editDialogVisible" width="576px">
            <el-form :model="editForm" label-position="left">
                <el-form-item label="品牌名称：">
                    <el-input v-model="editForm.name" placeholder="请输入安装产品" clearable style="width: 400px"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false" size="medium">取 消</el-button>
                <el-button type="primary" @click="EditProduct" size="medium" :loading="editload">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
    data() {
        return {
            editload: false,
            addLoad: false,
            tabload: false,
            page: 1,
            size: 10,
            total: 0,
            dialogVisible: false,
            editDialogVisible: false,
            editForm: {
                name: "",
            },
            formInline: {
                create_product_name: "",
            },
            tableData: [],
            id: null,
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {},
    methods: {
        ...mapActions({
            competeBrand: "brand/competeBrand",
            createCompeteBrand: "brand/createCompeteBrand",
            deleteCompeteBrand: "brand/deleteCompeteBrand",
            editCompeteBrand: "brand/editCompeteBrand",
            createCompeteProduct: "brand/createCompeteProduct",
        }),
        close() {
            this.$refs.formInline.resetFields();
            this.formInline = {
                create_product_name: "",
            };
            this.dialogVisible = false;
        },
        // 显示编辑品牌弹窗
        EditProShow(row) {
            this.id = row.id;
            this.editForm.name = row.name;
            this.editDialogVisible = true;
        },
        // 编辑品牌
        EditProduct() {
            this.editload = true;
            let params = {
                token: this.getToken,
                name: this.editForm.name,
                id: this.id,
            };
            this.editCompeteBrand(params).then(({ data }) => {
                this.editload = false;
                if (data.code == 1) {
                    this.$message.success("修改成功！");
                    this.editDialogVisible = false;
                    this.initTable(1);
                    this.$emit("initProduct");
                    this.$emit("init");
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 删除品牌
        deleteProduct(id) {
            this.$confirm("确实删除该品牌？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let params = {
                        id: id,
                        token: this.getToken,
                    };
                    this.deleteCompeteBrand(params).then(({ data }) => {
                        if (data.code == 1) {
                            this.$message.success("删除成功！");
                            this.initTable(0);
                            this.$emit("initProduct");
                            this.$emit("init");
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        // 初始化品牌列表和品牌下拉
        async initTable(tag) {
            let data = await this.getCompeteBrandList(tag, this.page, this.size);
            this.total = data.count;
            this.tableData = data.data;
        },
        // 添加品牌
        createProduct() {
            this.addLoad = true;
            let params = {
                token: this.getToken,
                name: this.formInline.create_product_name,
            };
            this.createCompeteBrand(params).then(({ data }) => {
                this.addLoad = false;
                if (data.code == 1) {
                    this.$message.success("添加成功!");
                    this.formInline.create_product_name = "";
                    this.initTable(0);
                    this.$emit("initProduct");
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 获取品牌列表
        async getCompeteBrandList(tag, page, size) {
            let params = {
                token: this.getToken,
                page: tag == 0 ? 1 : page,
                size: size,
            };
            let { data } = await this.competeBrand(params);
            if (data.code == 1) {
                let obj = {
                    data: data.data.list,
                    count: data.data.count,
                };
                return obj;
            } else {
                this.$message.error(data.msg);
            }
        },
        async bindData() {
            this.dialogVisible = true;
            this.initTable(0);
        },
        onSubmit() {
            this.initTable(0);
        },
        reset() {
            this.formInline = {
                product_name: "",
                goods_name: "",
                spec_name: "",
                create_product_name: "",
            };
        },
        handleSizeChange(val) {
            this.size = val;
            this.initTable(1);
        },
        handleCurrentChange(val) {
            this.page = val;
            this.initTable(1);
        },
    },
};
</script>

<style lang="scss" scoped>
.select-product {
    ::v-deep .has-gutter tr th {
        background-color: rgb(217, 236, 255) !important;
    }
    .pageList {
        text-align: right;
        margin-top: 20px;
    }
}
.link {
    a {
        margin: 0 8px;
    }
}
.el-table {
    height: 350px;
    overflow-y: auto;
}
</style>